import { useMutation } from "@tanstack/react-query";
import { http } from "../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../consts/api";

export const useChargeWithAffirmMutation = () => {
  return useMutation((req) => {
    return http.post(HTTP_ENDPOINTS.affirm.checkout(), {
      affirmPayment: {
        invoiceId: req.invoiceId,
        requestedAmount: req.requestedAmount,
        patientPhone: req.patientPhone,
        patientEmail: req.patientEmail,
        patientCountry: req.patientCountry,
        patientZipCode: req.patientZipCode,
      },
    });
  });
};
